import { FC } from "react";

// import { Button } from "capitalrx-components-2.0";

import GetTheApp from "@/components/GetTheApp/GetTheApp";
// import AdvantageCardCTA from "@/components/AdvantageCardCTA/AdvantageCardCTA";

import styles from "./AdvantageCardParentCTA.module.scss";

const AdvantageCardParentCTA: FC = () => {
  // const [showGetTheApp, setGetShowTheApp] = useState(false);

  /* function showExpansion() {
     setGetShowTheApp(!showGetTheApp);
   }

   const CTABox = () => {
    return (
      <>
        <AdvantageCardCTA />
        <div className={styles.ButtonAlignment}>
          <Button className={styles.CardButton} key={0} onClick={() => showExpansion()} iconLocation="left" color="darkblue" size="small">
            GET YOUR FREE CARD
          </Button>
        </div>
      </>
    );
  };

  const GetTheAppBox = () => {
    return (
      <>
        <button className={styles.ExitButton} onClick={() => showExpansion()}>
          <Icon name="x" />
        </button>
        <GetTheApp />
      </>
    );
   }; */

  return (
    <div className={styles.OuterContainer}>
      <GetTheApp />
    </div>
  );
};

export default AdvantageCardParentCTA;
